const ApiConstants = {
  ENDPOINT: {
    LOGIN: "/authentication",
    SLIDES: "/slides",
    SLIDES_COUNT: "/slides/count",
    GEN_REPORT: "/slides/gen-report",
    TASKS: "/tasks",
    AUDIT: "/audit",
    ACTIVE_USERS: "/api/users/active",
  },
  HEADER: {
    X_MS_BLOB_TYPE: "x-ms-blob-type",
  },
  SLIDES_DIRECTION: {
    PREV: "prev",
    NEXT: "next",
  },
  SLIDE_KEYS: {
    SLIDE_ID: "id",
    NAME: "name",
    STATE: "state",
    REVIEWER: "reviewer",
    REVIEW_TIME: "last_check_time",
    ASSIGNEE: "assignee",
    ASSIGNEE_ID: "assignee_id",
    IS_RBC: "is_rbc",
    CREATE_TIME: "create_time",
  },
  SLIDE_STATE: {
    PROCESSING: "processing",
  },
} as const;

export default ApiConstants;
